export default "__VITE_ASSET__Tn0DCtL$__"